import { useDispatch } from 'react-redux';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useTimer } from '../../hooks/useCountDown';

import { userRegisterPhone } from '../../store/actions/authorize';

const CounterDown = ({ millis, phone, reSend, color = '#fe941a' }) => {
   const dispatch = useDispatch();
   const { executeRecaptcha } = useGoogleReCaptcha();

   let sec = (millis / 1000).toFixed(0);
   const { seconds, minutes, reset, isActive } = useTimer(sec);

   const handleResend = async () => {
      if (!executeRecaptcha) {
         return;
      }
      const token = await executeRecaptcha();
      if (!token) {
         return;
      }

      const res = await dispatch(userRegisterPhone(phone, token));
      if (res?.data?.success) {
         reset();
         reSend(res.data);
      }
   };

   return (
      <>
         {isActive ? (
            <div
               style={{
                  display: 'flex',
                  fontSize: '1.4rem',
                  paddingBottom: '1rem',
                  justifyContent: 'center',
               }}
            >
               <p style={{ color }}>{`${seconds} : ${minutes}`}</p>
               <p style={{ color: '#21164b', marginRight: '.75rem' }}>مانده تا دریافت مجدد کد</p>
            </div>
         ) : (
            <p
               onClick={handleResend}
               style={{
                  textAlign: 'center',
                  fontSize: '1.3rem',
                  paddingBottom: '1rem',
                  color: '#21164b',
                  cursor: 'pointer',
               }}
            >
               ارسال مجدد کد{' '}
            </p>
         )}
      </>
   );
};

export default CounterDown;
